var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8307C15.9949 17.8288 14.459 18.4312 12.7807 18.4312C9.03582 18.4312 6 15.4316 6 11.7312C6 8.03094 9.03582 5.03125 12.7807 5.03125C14.459 5.03125 15.9949 5.63375 17.179 6.63179C18.363 5.63375 19.8989 5.03125 21.5773 5.03125C25.3221 5.03125 28.358 8.03094 28.358 11.7312C28.358 15.4316 25.3221 18.4312 21.5773 18.4312C19.8989 18.4312 18.363 17.8288 17.179 16.8307Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1787 16.8307C18.6366 15.6018 19.5611 13.7732 19.5611 11.7312C19.5611 9.68929 18.6366 7.86069 17.1787 6.63179C18.3628 5.63375 19.8987 5.03125 21.577 5.03125C25.3219 5.03125 28.3577 8.03094 28.3577 11.7312C28.3577 15.4316 25.3219 18.4312 21.577 18.4312C19.8987 18.4312 18.3628 17.8288 17.1787 16.8307Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1793 16.8307C18.6372 15.6018 19.5616 13.7732 19.5616 11.7313C19.5616 9.68933 18.6372 7.86074 17.1793 6.63184C15.7213 7.86074 14.7969 9.68933 14.7969 11.7313C14.7969 13.7732 15.7213 15.6018 17.1793 16.8307Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.41ad14adc36fdd8b6013780f996d7dfc.svg";
export { ForwardRef as ReactComponent };